import { Text, type TextStyle } from 'react-native'
import { styled } from '~/utils/styled'

import { convertLineHeight } from '~/utils'

export const Label = styled(Text, theme => {
  return {
    base: {
      height: theme.sizingExtrasmall,

      fontFamily: theme.fontFamily.bold,
      fontSize: theme.fontSizeThreeandhalfpulse,
      color: theme.colorTextNeutralDefault,

      alignContent: 'center',

      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
    },
    variants: {
      selected: {
        true: {
          color: theme.colorTextNeutralDefault,
        },
      },
      readOnly: {
        true: {
          color: theme.colorTextNeutralReadonly,
        },
      },
      disabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
      type: {
        input: {},
        singleFilter: {},
      },
    },

    compoundVariants: [
      {
        variants: {
          selected: true,
          readOnly: true,
        },
        css: {
          color: theme.colorTextNeutralDisabled,
        },
      },
      {
        variants: {
          type: 'singleFilter',
          readOnly: true,
        },
        css: {
          color: theme.colorTextNeutralDisabled,
        },
      },
    ],
  }
})
